import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "../../../common/method/handleNotificationAlert";

export const actionTypes = {
  selectEnteghalTalabRequest: "selectEnteghalTalabRequest [Action]",
  selectEnteghalTalabRequestLoading: "selectEnteghalTalabRequestLoading [Action]",
  selectEnteghalTalabRequestAsync: "selectEnteghalTalabRequestAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const select_enteghal_talab_request_reducer = (
  state = inistiaState,
  { type, payload },
) => {
  switch (type) {
    case actionTypes.selectEnteghalTalabRequest:
      return {
        ...state,
        data: payload,
        total: payload?.total,
      };
    case actionTypes.selectEnteghalTalabRequestLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.selectEnteghalTalabRequestLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "payment",
    method_type: "select_enteghal_talab_request",
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.selectEnteghalTalabRequest,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectEnteghalTalabRequestLoading,
      payload: false,
    });
  }
}

export function* selectEnteghalTalabRequest() {
  yield takeLatest(actionTypes.selectEnteghalTalabRequestAsync, handleWorker);
}
